// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import animated from 'animate.css'
import store from './vuex/store'
import moment from 'moment'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(animated)
Vue.prototype.$moment = moment

Vue.prototype.setLoading = (value) => {
  store.commit({
    type: 'setLoading',
    loading: value
  })
}

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js